import {
  ETHNICITY_TYPE,
  GENDER_TYPE,
  RACE_TYPE,
  RELATIONSHIP_TYPE,
  WILLINGNESS_TYPE,
} from '@common/types';
import {
  addOptionalNullableToSchema,
  pastDateSchema,
  emailSchema,
  internationalStateSchema,
  optionalNameSchema,
  optionalNullableNameSchema,
  phoneSchema,
  requiredErrorMessage,
  requiredNameSchema,
  textSchema,
  zipSchema,
} from '@common/schema';
import * as yup from 'yup';

export const addCaregiverSchema = yup.object().shape({
  first_name: requiredNameSchema,
  middle_name: optionalNameSchema,
  last_name: requiredNameSchema,
  birthdate: addOptionalNullableToSchema(pastDateSchema),
  gender: addOptionalNullableToSchema(
    yup.string().oneOf(Object.values(GENDER_TYPE)),
  ),
  race: addOptionalNullableToSchema(
    yup.string().oneOf(Object.values(RACE_TYPE)),
  ),
  ethnicity: addOptionalNullableToSchema(
    yup.string().oneOf(Object.values(ETHNICITY_TYPE)),
  ),
  relationship: yup
    .string()
    .oneOf(Object.values(RELATIONSHIP_TYPE))
    .required(requiredErrorMessage),
  willingness: addOptionalNullableToSchema(
    yup.string().oneOf(Object.values(WILLINGNESS_TYPE)),
  ),
  lives_with_patient: addOptionalNullableToSchema(textSchema),
  has_medicare: addOptionalNullableToSchema(textSchema),
  start_date: addOptionalNullableToSchema(pastDateSchema),
  google_places_id: addOptionalNullableToSchema(yup.string()),

  street: optionalNullableNameSchema,
  suite: optionalNullableNameSchema,
  state: internationalStateSchema,
  city: optionalNullableNameSchema,
  country: optionalNullableNameSchema,
  zip_code: addOptionalNullableToSchema(zipSchema),
  email: addOptionalNullableToSchema(emailSchema),
  phone_number: phoneSchema.required(requiredErrorMessage),
  phone_type: yup
    .string()
    .oneOf(Object.values(['Home', 'Cell', 'Business']))
    .required(requiredErrorMessage),
  primaryCaregiver: yup.string().oneOf(['true', 'false']),
  emergencyContact: yup.string().oneOf(['true', 'false']),
  powerOfAttorney: yup.string().oneOf(['true', 'false']),
  guardian: yup.string().oneOf(['true', 'false']),
  other: yup.string().oneOf(['true', 'false']),
});
